// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"849":"2afdeeb9","977":"99d4428c"}[chunkId] + ".chunk.js";
};